import { render, staticRenderFns } from "./NewPUAsset.vue?vue&type=template&id=4c8839a7&scoped=true&"
import script from "./NewPUAsset.vue?vue&type=script&lang=js&"
export * from "./NewPUAsset.vue?vue&type=script&lang=js&"
import style0 from "./NewPUAsset.vue?vue&type=style&index=0&id=4c8839a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8839a7",
  null
  
)

export default component.exports